import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { HoldToRecordButton } from '../contexts/HoldToRecordContext';
import { useSession } from '../contexts/SessionContext';
import { useLanguage } from '../contexts/LanguageContext';
import { ROUTES } from '../constants/routes';

export default function ShiftHandoverVoiceScreen() {
  const { patientKey } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { shiftHandoverDrafts, setHandoverRecordingTarget } = useSession();
  const decodedKey = decodeURIComponent(patientKey || '');
  const draft = shiftHandoverDrafts.find((d) => d.patientKey === decodedKey);

  useEffect(() => {
    if (!draft) return;
    setHandoverRecordingTarget({
      patientKey: draft.patientKey,
      patientId: draft.patientId,
      patientName: draft.patientName,
    });
    return () => setHandoverRecordingTarget(null);
  }, [draft, setHandoverRecordingTarget]);

  if (!draft) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-page p-8 text-center text-gray-500">
        Patient handover not found.
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-[#464E59]">
      <div className="flex justify-between px-4 pt-4">
        <button
          type="button"
          onClick={() => navigate(ROUTES.SHIFT_HANDOVER)}
          className="flex h-10 w-10 items-center justify-center text-white/90"
          aria-label="Back"
        >
          <ArrowLeft className="h-6 w-6" strokeWidth={2} />
        </button>
      </div>

      <p className="px-4 text-center text-lg font-medium text-white/90" dir="auto">
        {draft.patientName}
      </p>
      <p className="px-6 text-center text-sm text-white/70">
        Add voice context for the shift handover. Speak in Arabic, English, or both.
      </p>

      <div className="flex flex-1 flex-col items-center justify-end px-4 pb-40">
        <p className="record-hint-bottom fixed left-0 right-0 z-[95] px-4 text-center text-sm text-white/80">
          {t('holdToRecord')}
        </p>
        <HoldToRecordButton patientId={draft.patientId || null} size="fab" />
      </div>
    </div>
  );
}
